<template>
  <v-col md="6" class="pl-2">
    <v-card elevation="1" class="mb-4">
      <v-card-text style="min-height: 238px">
        <h6 class="text-h6 black--text">Totales</h6>
        <p class="text-body-2">Detalle de totales que componen la orden de pago</p>

        <v-row class="mt-6">
          <v-col md="12">
            <div class="d-flex justify-space-between align-center mb-3">
              <span class="text-body-1">Total a imputar:</span>
              <v-chip outlined color="blue">{{ formatUtils.formatPrice(totalImputar) }}</v-chip>
            </div>
            <div class="d-flex justify-space-between align-center mb-3">
              <span class="text-body-1">Total retenciones:</span>
              <v-chip outlined color="blue">{{ formatUtils.formatPrice(subtotalRetenciones) }}</v-chip>
            </div>
            <div class="d-flex justify-space-between align-center">
              <span class="text-h6 font-weight-bold">Total a pagar:</span>
              <v-chip class="font-weight-bold" color="primary">{{ formatUtils.formatPrice(total) }}</v-chip>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import { formatUtils } from "@/libs/utils/formatUtils";
export default {
  components: {},
  props: { 
    total: Number,
    totalImputar: { type: Number, default: 0 },
    subtotalRetenciones: { type: Number, default: 0 }
  },
  data: () => ({
    formatUtils: formatUtils,
  }),
  watch: {},
  mounted() {},
  methods: {},
};
</script>
